<template>
  <div class="setListName">
    <div v-if="visible" class="modal_2">
      <div class="add add_pof">
        <div class="add_form add_pof">

          <div class="list_box">
            <Editor :form='form' @input='input' key="setListName"></Editor>
          </div>

          <div class="share_bot">
            <a-button @click="handleCancel">取消</a-button>
            <a-button @click='handleOk' type="primary">
              确定
            </a-button>
          </div>

        </div>
      </div>
    </div>

  </div>
</template>

<script>

import Editor from "@/components/Editor";
export default {
  name: "setListName",
  components: {
    Editor,
  },
  data() {
    return {
      visible: false,
      getData: {},
      getIndex: '',
      form: {
        data: {
          desc: ''
        }
      },
    };
  },
  computed: {
  },
  methods: {
    showModal(data, index) {
      this.getData = data
      this.getIndex = index
      this.form.data.desc = data.list_item_name || data.title
      this.visible = true;
    },
    input(newValue) {
      this.form.data.desc = newValue
    },
    handleCancel() {
      this.visible = false;
    },
    handleOk() {
      this.getData.list_item_name = this.form.data.desc
      this.getData.list_item_index = this.getIndex
      this.$emit('giveListname', this.getData)
      this.visible = false;
    },
  },
};
</script>
<style lang="less" scoped>
.jumpWhere {
  display: flex;
  line-height: 32px;
  margin-bottom: 12px;

  span {
    // margin-right: 10px;
  }

  input {
    flex: 1;
  }
}

.searchBox {
  height: 32px;
  margin-bottom: 20px;
  padding: 0 20px;
  display: flex;
  // justify-content: space-between;
}

.showModal2 {
  font-weight: 500;
  font-size: 14px;
  border-radius: 2px;
  color: #1890ff;
  line-height: 20px;
  text-align: center;
  font-style: normal;
  border: 1px solid rgba(25, 144, 255, 0.5);
}

.showModal2_reload {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;

  img {
    margin-right: 5px;
  }
}

.searchBox .ant-input-search {
  width: 240px;
}

.list_box {
  padding: 20px;
  flex: 1;
}

:deep(.ant-calendar-picker) {
  width: 100%;
}

.jumpWhere {
  input {
    border-radius: 4px 0 0 4px;
  }

  button {
    border-radius: 0 4px 4px 0;
  }
}

.add_pof {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  margin: auto;
  z-index: 999;
}

.add {
  background-color: rgba(0, 0, 0, 0.6);
}

.add_form {
  width: 1000px;
  height: 550px;
  border-radius: 8px;
  background-color: #fff;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  bottom: 0;
  top: 0;
}

.h625 {
  height: 625px;
}

.add_form_title {
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
  height: 46px;
  background: #f3f6f9;
  padding: 0 20px;
  font-size: 14px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 500;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.85);
  align-items: center;
  color: rgba(0, 0, 0, 0.85);

  .add_form_close {
    color: #818181;
    display: inline-block;
    width: 46px;
    height: 46px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    right: 3px;
  }
}

.add_formBox {
  padding: 20px 0px 20px 0px;
  margin: 0 20px;
  flex: 1;
}

.add_formBoxTwo {
  padding: 21px 0;
  display: flex;
  flex-direction: column;
  padding-bottom: 0;
}

.add_formBox_item {
  display: flex;
  align-items: center;
  border-bottom: 1px solid #eff0f2;
  padding-bottom: 20px;
}

.add_formBox_name {
  text-align: right;
  padding-right: 16px;
  width: 100px;
  font-size: 14px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.85);
}

.add_formBox_inp {
  height: 36px;
  border-radius: 4px;
  font-size: 14px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.85);
  flex: 1;
  margin: 0 10px 0 0px;
}

.begin_time,
.meeting_name {
  max-width: 400px;
  width: 100%;
}

.add_formBox_btn {
  font-size: 14px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 600;
  margin-right: 16px;
  color: #1890ff;
}

.add_formBox_btn:last-child {
  margin-right: 20px;
}

.share_bot button {
  margin-left: 12px;
}

.share_bot {
  border-top: 1px solid #e3e4e8;
  height: 68px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding-right: 20px;
}

:deep(.ant-table-thead) {
  height: 48px;

  tr {
    th {
      background: #f3f6f9;
      height: 48px;
      padding: 0 16px;
    }
  }
}

:deep(.ant-table-tbody) {
  height: 48px;

  tr {
    td {
      height: 59px;
    }
  }
}

.setListName :deep(.title) {
  display: none;
}

.status {
  display: flex;
  width: 62px;
  align-items: center;
  justify-content: center;
  height: 20px;
  border-radius: 10px;
  font-weight: 400;
  font-size: 12px;
  line-height: 17px;
  text-align: left;
  font-style: normal;

  img {
    width: 12px;
    margin-right: 2px;
  }
}

.status_wks {
  border: 1px solid #2bb840;
  color: #2bb840;
}

.status_zbz {
  border: 1px solid #1890ff;
  color: #1890ff;
}

.status_yjs {
  border: 1px solid #eb5d44;
  color: #eb5d44;
}
</style>